import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";

function getCascadeWarning(userRole) {
    if (!userRole || userRole.siteUuid) return null;
    return userRole.contractUuid
        ? "This also removes this user's roles on every site of the contract."
        : "This also removes this user's roles on every contract and site of the company.";
}

export function DeleteUserRoleDialog({ open, userRole, onClose, onConfirm }) {
    const cascadeWarning = getCascadeWarning(userRole);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirm deletion</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to remove this user role?
                    {cascadeWarning && ` ${cascadeWarning}`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} color="error" autoFocus>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}

DeleteUserRoleDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    userRole: PropTypes.shape(MODEL_PROPTYPES.UserRole),
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
